import {
  ComponentProps,
  forwardRef,
  PropsWithChildren,
  ReactNode,
} from 'react';

import { cn } from '@components/primitives';

import { Edge } from '@components/features/Layout/Navigation/SlantedButton/Edge';

import css from './styles.module.css';

export interface SlantedButtonProps
  extends PropsWithChildren<ComponentProps<'button'>> {
  suffix?: ReactNode;
}

export const SlantedButton = forwardRef<HTMLButtonElement, SlantedButtonProps>(
  function SlantedButton({ children, className, suffix, ...props }, ref) {
    return (
      <button ref={ref} className={cn(css.trigger, className)} {...props}>
        <div className={css.triggerBackground}>
          <Edge className={css.edge} />
          <Edge className={css.edge} />
        </div>

        <span className={css.content}>{children}</span>

        {suffix && (
          <span className={css.suffix} aria-hidden>
            {suffix}
          </span>
        )}
      </button>
    );
  }
);
